<div style="height: 90%">
    <div style="display: flex; align-items: center; justify-content: end">
        <button [matTooltip]="'ManagePage.BussionConnector' | translate" mat-stroked-button
            class="custom-primary-stroked-button mr-10" [routerLink]="['/landing/connectors']">
            <mat-icon svgIcon="home"></mat-icon>
        </button>
        <div style="margin-right: 20px; width: 35%">
            <app-search-input (changeText)="searchData($event)" [height]="'36px'"></app-search-input>
        </div>
        <button (click)="routeToDesigner()" mat-raised-button class="custom-primary-button button-md w-100 mt-10">
            <mat-icon>add</mat-icon>
            <span>{{ "FlowPage.AddFlow" | translate }}</span>
        </button>
    </div>


    <div  *ngIf="!loading && paginatedFlowList.length <= 0" style="text-align: center;margin-top: 5px;width: 100%;height: 100%;color: rgb(134, 153, 217);font-weight: bold;font-size: 1rem;box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);min-height: 50vh;
    display: flex; align-items: center;justify-content: center; flex-direction: column;">
       <svg  style="width: 5rem" fill="#8699d9" viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style> .cls-1 { fill: none; } </style> </defs> <title>flow--connection</title> <path d="M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z"></path> <rect id="_Transparent_Rectangle_" data-name="<Transparent Rectangle>" class="cls-1" width="32" height="32"></rect> </g></svg>

        <p style="font-size: 1.5rem; margin-top: 0.5rem">
            {{ "FlowPage.NoFlowsYet" | translate }}
        </p>
        <p style="font-weight: lighter">
            {{ "FlowPage.NoFlowsYetParagraph" | translate }}
        </p>
    </div>
    <div class="cards-section" *ngIf="!loading && flowList.length > 0">
        <app-card-with-actions *ngFor="let item of paginatedFlowList" [item]="item" [keys]="cardKeys"
            [imageAvatarKeys]="imageAvatarKeys" [icons]="createCardInfo(item.ownerId)"
            (cardTitleClick)="openEditDesigner($event)"></app-card-with-actions>
    </div>
</div>
<div style="height: 10%" *ngIf="flowList.length > 0">
    <mat-paginator [length]="pageVariables.listLength" [pageSize]="pageVariables.itemPerPage"
        (page)="handlePageEvent($event)" [pageSizeOptions]="[]" aria-label="Select page">
    </mat-paginator>
</div>